<template>
  <div class="service-plan">
    <div v-if="infolist !== ''" class="body-around-if">
      <div v-for="(item,index) of infolist" :key="index" class="body-around">
        <dr-maintenance :info-list="aroundlist[index]">
          <div class="opera">
            <ul class="base-info">
              <li class="info-item">
                <div class="info_label">
                  <split-label :label="$t('maintenanceState')" class-name="label" />
                </div>
                <div class="info_value complete-btn">
                  {{ item.repairStatus }}
                </div>
              </li>
            </ul>
            <div class="detail-btn-wrapper">
              <button class="detail-btn detail-btn-detail" @click="toMeiQia(item)">
                咨询该报修单
              </button>
            </div>
          </div>
        </dr-maintenance>
      </div>
    </div>
    <div v-if="infolist === [] || infolist.length === 0 || infolist === null" class="null-state">
      <img alt="" src="@/assets/images/img_blank@2x.png">
      <p>请先报修再咨询</p>
    </div>
  </div>
</template>

<script>
import DrMaintenance from '@/components/Maintenance'
import { RECORD_STATUS, REPAIR_STATUS } from '@/api/constants'
import { MeiQiaEntId, MeiQiaLoader, MeiQiaToken } from '@/utils/routeList'

export default {
  name: 'ServiceEvaluate',
  components: { DrMaintenance },
  data() {
    return {
      'meiQiaInfo': {
        code: 0, // 成功返回0，失败返回值 < 0
        data: {}, // 成功返回相应的数据，失败返回 null
        message: 'string', // 成功无该字段，失败返回相应的错误信息
        trackId: ''
      },
      searchCriteria: {},
      Year: '', // 选择年份
      numberInput: '', // 搜索输入内容
      columns: [], // 选择器
      selevtList: [], // 下拉列表
      timeInfo: '', // 筛选时间
      currentDate: new Date(), // 选择时间
      aroundlist: [], // 信息列表
      infolist: [] // 用户信息列表
    }
  },
  mounted() {
    this.init()
    // eslint-disable-next-line no-undef
    _MEIQIA('hidePanel')
    this.repairInfo()
    this.handleInfoList()
    this.selevtList = RECORD_STATUS // 下拉列表内容
  },
  methods: {
    // 美洽唤起客服
    toMeiQiaNoDcode() {
      this.$api('USER_INFO_H5').then((res) => {
        const userInfoList = res.result
        const { province, city, name, phonenum, hospitalName, hospitalDepartment, hospitalPosition, hospitalAddress } = userInfoList
        // eslint-disable-next-line no-undef
        _MEIQIA('metadata', {
          '姓名': name,
          '电话号': phonenum,
          '所属医院': hospitalName,
          '医院科室': hospitalDepartment,
          '所属职位': hospitalPosition,
          '所属地址': hospitalAddress,
          '省份': province,
          '城市': city
        })
      })
      // eslint-disable-next-line no-undef
      _MEIQIA('showPanel')
    },
    /* 用户信息*/
    handleInfoList() {
      this.$api('USER_INFO_H5').then((res) => {
        this.userInfoList = res.result
      })
    },
    /* 找客服*/
    toMeiQia(item) {
      const { province, city, name, phonenum, hospitalName, hospitalDepartment, hospitalPosition, hospitalAddress } = this.userInfoList
      // eslint-disable-next-line no-undef
      _MEIQIA('metadata', {
        '出厂编号': item.deviceCode,
        '订单地址': process.env.VUE_APP_MEIQIA_CALLBACK + item.id,
        '姓名': name,
        '电话号': phonenum,
        '所属医院': hospitalName,
        '医院科室': hospitalDepartment,
        '所属职位': hospitalPosition,
        '所属地址': hospitalAddress,
        '省份': province,
        '城市': city
      })
      // eslint-disable-next-line no-undef
      _MEIQIA('showPanel')
    },
    init() {
      (function(a, b, c, d, e, j, s) {
        a[d] = a[d] || function() {
          (a[d].a = a[d].a || []).push(arguments)
        }
        j = b.createElement(c)
        s = b.getElementsByTagName(c)[0]
        j.async = true
        j.charset = 'UTF-8'
        j.src = MeiQiaLoader
        s.parentNode.insertBefore(j, s)
      })(window, document, 'script', '_MEIQIA')
      // eslint-disable-next-line no-undef
      _MEIQIA('entId', MeiQiaEntId)
      // eslint-disable-next-line no-undef
      _MEIQIA('assign', {
        agentToken: MeiQiaToken
      })
      // eslint-disable-next-line no-undef
      _MEIQIA('withoutBtn')
    },
    /*
      获取列表
     */
    repairInfo() {
      this.searchCriteria.repairStatusIn = ['TRANSMITTED', 'ALREADY_SUBMIT', 'ALREADY_ALLOT', 'ALREADY_DISPOSE', 'ACCEPTED', 'TRANSMITTED_ERROR']
      const list = Object.keys(this.searchCriteria)
      list.forEach((item) => {
        if (this.searchCriteria[item] === '') {
          delete this.searchCriteria[item]
        }
      })
      this.$api('REPAIR_SEARCH_H5', this.searchCriteria
        , true).then((res) => {
        this.infolist = res.result.content
        this.infolist.forEach((item, index) => {
          item.repairStatus = REPAIR_STATUS[item.repairStatus]
          this.aroundlist[index] = [
            { title: '出厂编号', content: item.deviceCode },
            { title: '型  号', content: item.model },
            { title: '报修时间', content: item.inputDate }
          ]
        })
        this.searchCriteria.repairStatus = REPAIR_STATUS[this.searchCriteria.repairStatus]
      }).catch(() => {
        this.searchCriteria.repairStatus = REPAIR_STATUS[this.searchCriteria.repairStatus]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.repairs-content-voice-title{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
  .content-voice-title{
    width: 50px;
  }
  .content-voice-del{
    color: #005BAC;
    text-decoration:underline;
  }
}
.des
.info_label {
  font-weight: 700;
}

::v-deep .van-cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 0 0 0 9.5px;
  overflow: hidden;
  color: #323233;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  background-color: #fff;
}

.info_value {
  font-weight: 700;

  .btn-color {
    color: #009966;
  }
}

::v-deep .dr__maintenance .base-info {
  padding: 27px 16px;

  .info-item {
    display: flex;
  }
}

.service-plan {
  padding: 13.5px 15px;
  .server-text {
    border-bottom: #333333 1px solid;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-content: center;
    padding: 17px 15px;
    align-items: center;
    text-align: center;
    font-size: 20px;
    color:  rgba(0, 91, 172, 1);
  }
  .null-state {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 140px;
    img {
      width: 190px;
      height: 140px;
    }
    p {
      color: #999999;
      font-size: 15px;
    }
  }
  .null-state-img {
    width: 380px;
    height: 380px;
  }
  .serach-around {
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    height: 40px;
    margin-bottom: 10px;
    padding: 5px 15px;
    align-items: center;

    .number-input {
      border-radius: 5px;
      width: 170px;
      padding-left: 8.5px;
      border: 0.5px #F2F2F2 solid;
      font-size: 12px;
    }

    .around-select-img {
      width: 19px;
      height: 19px;
      margin-left: 9px;
    }

    .van-cell-state {
      height: 25px;
      border: none;
      font-size: 12px;
      width: 125px;
      padding: 0;
    }

    .serach-around-select {
      display: flex;
      align-items: center;
      width: 120px;
      margin-right: 10px;
      border: solid 0.5px #F2F2F2;
      border-radius: 5px;
      padding: 0 5px;

      .cell-state-img {
        width: 10px;
        height: 10px;
      }

      ::v-deep .van-field__control:read-only {
        padding-left: 3.5px;
        font-size: 12px;
      }
    }

    .serach-around-btn {
      height: 30px;
      width: 60px;
      border: none;
      font-size: 15px;
      margin-left: 15px;
    }
  }

  .body-around {
    background-color: #fff;
    margin-bottom: 13.5px;
    border-radius: 5px;
  }

  .opera {
    position: relative;

    .complete-btn {
      color: rgba(0, 91, 172, 1);
    }

    .detail-btn-wrapper {
      top: 0 !important;
      left: 250px;
      height: 100%;
      display: flex;
      flex-direction: row-reverse;

      .detail-btn {
        height: 30px;
        margin-right: 11px;
        margin-bottom: 17px;
        border: none;
        outline: none;
        padding: 9px 12px;
        background: #005BAC;
        border-radius: 15px;
        display: flex;
        align-items: center;
        margin-top: -50px;
        font-size: 13px;
        font-family: PingFang SC Medium, PingFang SC Medium-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 13.5px;
      }

      .detail-btn-detail {
        border: #009966 1px solid;
        color: #009966;
        background-color: #ffffff;
      }
    }
  }
}
</style>
